module.exports = __webpack_public_path__ + "img/courier-saia.ee011a01.svg";